import { render, staticRenderFns } from "./CustomElement.vue?vue&type=template&id=2e2aae75&scoped=true&"
import script from "./CustomElement.vue?vue&type=script&lang=js&"
export * from "./CustomElement.vue?vue&type=script&lang=js&"
import style0 from "./CustomElement.vue?vue&type=style&index=0&id=2e2aae75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2aae75",
  null
  
)

export default component.exports